import React from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle,SocialMediaIcons,SocialMediaIcon, ResumeButton ,StyledCanvasWrapper} from './HeroStyle'
import LogoImage from '../../images/logo.png'
import Typewriter from 'typewriter-effect';
import RobotExperience from '../Three/Robot';
import { usePortfolioData } from '../../context/PortfolioDataContext';

const HeroSection = () => {
  const { data, errorMessage } = usePortfolioData();
  const bioData = data?.bio;

  if (errorMessage) {
    return (<div className="loader">{errorMessage}</div>)
  }

  if (!bioData) {
    return (<div className="loader">Loading...</div>)
  }


    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {bioData.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: bioData.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{bioData.description}</SubTitle>
                        <ResumeButton href={bioData.resume} target='display'>Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <StyledCanvasWrapper>
                            <RobotExperience />
                        </StyledCanvasWrapper>
                        {/* <Img src={LogoImage} alt="Logo-image" /> */}
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
        </div>
    )
}

export default HeroSection
